import * as React from 'react';
export const almaSvg = React.forwardRef(function almaSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#FA5022',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#fff',
      d: 'M20.792 10.82C19.857 7.204 17.87 6 16 6c-1.87 0-3.857 1.205-4.792 4.82L7 26h4.09c.702-2.53 2.69-3.976 4.91-3.976S20.208 23.47 20.91 26H25l-4.208-15.18ZM16 18.53c-1.286 0-2.454.482-3.273 1.325l2.338-8.915c.234-.844.584-1.085 1.052-1.085s.818.241 1.052 1.085l2.338 8.915c-1.052-.843-2.221-1.325-3.507-1.325Z',
    }),
  );
});
almaSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var alma = {
  category: 'brand',
  colorable: false,
  name: 'alma',
  svg: almaSvg,
};
